// Version : 0.0.3
// Author : VIGNESH
// LastEdit: VIGNESH
// MODFIED DATE : 07-12-2025
// LAST MOFIFIED: ADDED COMMENTS AND REMOVED UNWANTED REDUX

import { takeLatest, put, all, call } from 'redux-saga/effects';
import GoldLoanInterestReminderReportTypes from './gold-loan-interest-reminder-report.types';
import { requestReportDetailsFetch } from './gold-loan-interest-reminder-report.service';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	getGoldLoanInterestReminderFailure,
	getGoldLoanInterestReminderResponseChanged,
	getGoldLoanInterestReminderSucess,
} from './gold-loan-interest-reminder-report.action';
import GoldloanInterestReminderReportTypes from './gold-loan-interest-reminder-report.types';

/** *********************  START GOLD LOAN INTEREST REMAINDER REPORT DETAILS  ******************** */
export function* fetchGoldLoanInterestReminderReportDetails({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			reportFromDate,
			reportToDate,
			branchID,
			centerID,
			groupID,
			funderID,
		} = payload;
		const key = 'FetchGoldLoanInterestReminderKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			ReportFromDate: reportFromDate,
			ReportToDate: reportToDate,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			FunderID: funderID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(requestReportDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldLoanInterestReminderFailure(responseData.data));
		} else {
			yield put(getGoldLoanInterestReminderSucess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldLoanInterestReminderFailure(error));
	}
}

export function* resetFetchGoldLoanInterestReminderResponse() {
	yield put(getGoldLoanInterestReminderResponseChanged());
}

export function* onFetchGoldLoanInterestReminderResponseDetails() {
	yield takeLatest(
		GoldloanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_START,
		fetchGoldLoanInterestReminderReportDetails,
	);
}

export function* onFetchGoldLoanInterestReminderResponseReset() {
	yield takeLatest(
		GoldLoanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_RESPONSE_RESET,
		resetFetchGoldLoanInterestReminderResponse,
	);
}

/** *********************  START GOLD LOAN INTEREST REMAINDER REPORT DETAILS  ******************** */

export function* GoldLoanInterestReminderReportSaga() {
	yield all([
		call(onFetchGoldLoanInterestReminderResponseDetails),
		call(onFetchGoldLoanInterestReminderResponseReset),
	]);
}
